import "./faq-overview.scss";

const selectors = {
  faq: "[data-faq]",
  faqGroup: "[data-faq-group]",
  faqAnchor: "[data-faq-anchor]",
};

const initFAQOverview = (faq) => {
  const faqAnchors = [...faq.querySelectorAll(selectors.faqAnchor)].map(
    (element) => ({
      id: decodeURI(element.hash).slice(1),
      element: element,
    })
  );

  const observedBlocks = [...faq.querySelectorAll(selectors.faqGroup)];

  const observer = new IntersectionObserver(
    () => {
      const firstVisibleBlock = observedBlocks.find(
        (block) => block.getBoundingClientRect().top >= 90
      );

      faqAnchors?.forEach((link) =>
        link.element.setAttribute(
          "data-active",
          firstVisibleBlock && link.id === firstVisibleBlock.id
        )
      );
    },
    {
      root: null,
      rootMargin: `-90px 0px 0px`,
      threshold: [0, 1],
    }
  );

  observedBlocks.forEach((block) => observer.observe(block));
};

document.addEventListener("DOMContentLoaded", async function () {
  const faq = document.querySelectorAll(selectors.faq);

  faq.forEach(initFAQOverview);
});
